import script from "./CheckmarkSvg.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckmarkSvg.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__